import TakePaymentBlock from './TakePaymentBlock/TakePaymentBlock'
import SettingsBlock from './SettingsBlock/SettingsBlock'

export { TakePaymentBlock, SettingsBlock }
